import { createSlice } from "@reduxjs/toolkit";
import {
  fetchReferralByID,
  fetchReferralsItems,
  updateReferral,
} from "./ReferralsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
  referralDetails: null,
  updateSuccess: false,
};

const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {
    resetUpdateSuccess: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralsItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchReferralsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // update referral
      .addCase(updateReferral.pending, (state) => {
        state.updateSuccess = false;
        state.error = null;
      })
      .addCase(updateReferral.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.items.findIndex((item) => item._id === updated._id);
        if (index !== -1) {
          state.items[index] = updated;
        }
        if (state.referralDetails?._id === updated._id) {
          state.referralDetails = updated;
        }
        state.updateSuccess = true; 
      })
      .addCase(updateReferral.rejected, (state, action) => {
        state.updateSuccess = false;
        state.error = action.error.message;
      })
      .addCase(fetchReferralByID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralByID.fulfilled, (state, action) => {
        state.loading = false;
        state.referralDetails = action.payload;
      })
      .addCase(fetchReferralByID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetUpdateSuccess } = referralsSlice.actions;

export default referralsSlice.reducer;
